import { LVStrings } from "@my-dld/assets/strings";
import ServiceDescriptions from "@my-dld/assets/strings/property_serv_desc";
import { PropertyService, PropertyServiceItem } from "@10x/coreapp/PropertyService";
import { showProperties } from "./NavigationUtils";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { resetData, updateSearchParams } from "./Utils";
import { SearchParams } from "./api/entities";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";

const AddProperty: PropertyServiceItem = {
	id: "add_your_property",
	label: LVStrings.add_your_property,
	action: serviceHandler,
	descriptionProvider: ServiceDescriptions,
	allowUnverifiedEmailUsers: false,
	isEnabled: isEnabled,
	requiredFeature: "addPropertyOnLand",
};

function serviceHandler( property: AssetCard, service: PropertyServiceItem, options?: any ) {
	resetData();
	setSearchParams( property );
	showProperties();
}

function setSearchParams( property: AssetCard ) {
	let landNo: string | undefined, landSubNo: string | undefined, munNo: string | undefined,
		munSubNo: string | undefined;
	if ( property.landNo ) {
		const array = property.landNo.split( "-" );
		landNo = array[ 0 ];
		landSubNo = array[ 1 ];
		landNo = !isEmptyStringOrNull( landNo ) ? landNo : "0";
		landSubNo = !isEmptyStringOrNull( landSubNo ) ? landSubNo : "0";
	}
	if ( property.municipalityNo ) {
		const array = property.municipalityNo.split( "-" );
		munNo = array[ 0 ];
		munSubNo = array[ 1 ];
		munNo = !isEmptyStringOrNull( munNo ) ? munNo : "0";
		munSubNo = !isEmptyStringOrNull( munSubNo ) ? munSubNo : "0";
	}
	const searchParams: SearchParams = {
		isFromLand: true,
		landNo: landNo,
		landSubNo: landSubNo,
		munNo: munNo,
		munSubNo: munSubNo,
		landPropertyId: property.propertyId,
	};
	updateSearchParams( searchParams );
}

function isEnabled( property: AssetCard, service: PropertyService, options?: any ) {
	return  property.propertyTypeId === TabuPropertyType.LAND && !property.isFreeHold;
}

export function registerPropertyService( propertyService: PropertyService ) {
	propertyService.registerService( AddProperty );
}
